import * as React from "react";
import { BaseIcon, BaseIconProps, BaseSVGIconProps } from "./BaseIcon";

const SvgTriangleDown = ({
  color,
  alt,
  "aria-roledescription": roleDescription = "Triangle Pointing Down",
  ...restProps
}: BaseSVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    {...restProps}
  >
    <title>{alt}</title>
    {roleDescription ? <desc>{roleDescription}</desc> : null}
    <path
      d="M10.0154 4.76531L6.26536 8.51531C6.23054 8.55018 6.18918 8.57784 6.14365 8.59671C6.09813 8.61558 6.04933 8.62529 6.00005 8.62529C5.95077 8.62529 5.90197 8.61558 5.85645 8.59671C5.81092 8.57784 5.76957 8.55018 5.73474 8.51531L1.98474 4.76531C1.93223 4.71287 1.89647 4.64602 1.88198 4.57324C1.86748 4.50046 1.87491 4.42501 1.90332 4.35645C1.93172 4.28789 1.97984 4.22931 2.04156 4.1881C2.10328 4.1469 2.17584 4.12494 2.25005 4.125H9.75005C9.82426 4.12494 9.89682 4.1469 9.95855 4.1881C10.0203 4.22931 10.0684 4.28789 10.0968 4.35645C10.1252 4.42501 10.1326 4.50046 10.1181 4.57324C10.1036 4.64602 10.0679 4.71287 10.0154 4.76531Z"
      fill={color ?? "#4D6670"}
    />
  </svg>
);

const TriangleDown = (props: BaseIconProps) => (
  <BaseIcon {...props}>
    <SvgTriangleDown />
  </BaseIcon>
);

export default TriangleDown;
